<template>
  <Row style="margin:3px 0px;">
    <i-col>
      <div
        class="ajax-field"
        @keyup.up="handleUpKey"
        @keyup.down="handleDownKey"
        @keyup.enter="handleOptionSelect(-1)"
        @keyup.esc="
          value = '';
          focus = false;
        "
      >
        <input
          v-model="value"
          type="text"
          @input="handleSearch"
          @focus="focus = true"
          @blur="handleBlur"
          placeholder="search..."
        />
        <div class="menu" v-show="menuDown">
          <template v-if="loading">
            <div class="item">Loading...</div>
          </template>
          <template v-else-if="error">
            <div class="item">No results</div>
          </template>
          <template v-else>
            <div
              class="item"
              :class="focusIndex === i && 'focus'"
              v-for="(option, i) in options"
              :ref="`option${i}`"
              :key="option.place_id"
              @click="handleOptionSelect(i)"
              @keyup.enter="handleOptionSelect(i)"
              @mouseenter="handleOptionFocus(i)"
              @mouseleave="handleOptionBlur(i)"
            >
              <div>
                <span>{{ option.name }}</span>
                <span class="type">{{ option.type }}</span>
              </div>
              <div class="country">{{ option.country }}</div>
              <div class="description">{{ option.display_name }}</div>
            </div>
          </template>
        </div>
      </div>
    </i-col>
  </Row>
</template>

<script>
import axios from "axios";

let timeout = null;

export default {
  props: ["iso"],
  data() {
    return {
      value: "",
      options: [],
      focusIndex: 0,
      focus: false,
      loading: false,
      error: false,
    };
  },
  mounted() {
    window.geolocation = this;
  },
  computed: {
    menuDown() {
      // return true;
      // return this.focus || this.loading;
      return (this.options.length > 0 && this.focus) || this.loading;
      //   return (
      //     (this.options.length > 0 && this.focus) || this.loading || this.error
      //   );
    },
  },
  methods: {
    search(phrase, iso) {
      this.loading = true;
      this.error = false;
      let url = `https://osmnames.idmcdb.org/q/${phrase}`;
      if (iso) {
        url = `https://osmnames.idmcdb.org/${this.iso}/q/${phrase}`;
      }
      axios
        .get(url)
        .then(response => {
          this.options = response.data.results;
          this.focusIndex = 0;
          this.focus = true;
          this.loading = false;
          window.scaffold = this;
        })
        .catch(error => {
          console.error(error);
          this.options = [];
          this.loading = false;
          this.error = true;
        });
    },
    handleSearch() {
      if (this.value && this.value.length > 3) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.search(this.value, this.iso);
        }, 1000);
      }
    },
    handleOptionSelect(i) {
      console.log(i, "selected");

      if (i === -1) {
        i = this.focusIndex;
      }
      this.$emit("select", this.options[i]);
      this.focusIndex = 0;
      this.focus = false;
      this.value = "";
    },
    handleOptionFocus(i) {
      this.focusIndex = i;
      this.$emit("focus", this.options[i]);
    },
    // handleOptionBlur() {},
    handleBlur() {
      // this.value = "";
      // this.options = [];
      // this.loading = false;
      // this.error = false;
      this.$emit("blur");
    },
    handleUpKey() {
      if (this.focusIndex > 0) {
        this.focusIndex--;
        this.$refs[`option${this.focusIndex}`][0].scrollIntoView(true);
        this.handleOptionFocus(this.focusIndex);
      }
    },
    handleDownKey() {
      if (this.focusIndex < this.options.length - 1) {
        this.focusIndex++;
        this.$refs[`option${this.focusIndex}`][0].scrollIntoView(true);
        this.handleOptionFocus(this.focusIndex);
      }
    },
  },
};
</script>

<style>
.ajax-field input {
  width: 100%;
  font-size: 1.2em;
  padding: 3px 9px;
}

.ajax-field .menu {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 0 0 3px 3px;
  position: absolute;
  background-color: white;
  z-index: 999999;
  max-height: 256px;
  overflow: auto;
  line-height: 1.3em;
  box-shadow: 0px 1px 3px #eee;
}

.ajax-field .menu .item {
  font-size: 1.1em;
  padding: 9px 6px 9px 6px;
  /* white-space: nowrap; */
  overflow: auto;
}

.ajax-field .menu .item .type {
  float: right;
  color: #bbb;
  font-size: 0.9em;
}

.ajax-field .menu .item .description {
  color: #bbb;
  font-size: 0.8em;
}

.ajax-field .menu .item .country {
  color: #828c97;
  font-size: 0.8em;
}

.ajax-field .menu .item:hover {
  cursor: pointer;
}

.ajax-field .menu .item.focus {
  background-color: #eee;
}
</style>
